"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YondFinishService = void 0;
var object_service_1 = require("@services/object-service");
var settings_service_1 = require("@services/settings.service");
var api_wrapper_1 = require("@src/api/api-wrapper");
var input_mapping_const_1 = require("@src/const/input.mapping.const");
var cash_dom_1 = __importDefault(require("cash-dom"));
var YondFinishService = /** @class */ (function () {
    function YondFinishService() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
    }
    YondFinishService.prototype.handleYondFinish = function ($container_1) {
        return __awaiter(this, arguments, void 0, function ($container, forceRefresh) {
            var agbElement, legalEntityElement, legalEntityOid, legalEntityNameStorage, legalEntityAGB, apiWrapper, studios, currentStudioId_1, yondStudio;
            var _a;
            if (forceRefresh === void 0) { forceRefresh = false; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        agbElement = $container.find('[data-get="yondAGB"]');
                        legalEntityElement = $container.find('[data-get="legalEntity.name"]');
                        legalEntityOid = localStorage.getItem('legalEntityOid');
                        legalEntityNameStorage = localStorage.getItem('legalEntity.name');
                        legalEntityAGB = localStorage.getItem('legalEntity.agb');
                        if (!(agbElement.length > 0 || legalEntityElement.length > 0)) return [3 /*break*/, 3];
                        if (!(!legalEntityNameStorage || !legalEntityAGB || forceRefresh)) return [3 /*break*/, 2];
                        apiWrapper = object_service_1.ObjectService.getInstance(api_wrapper_1.ApiWrapper);
                        return [4 /*yield*/, apiWrapper.getStudios()];
                    case 1:
                        studios = _b.sent();
                        currentStudioId_1 = (_a = localStorage.getItem(input_mapping_const_1._AllMappings.studioId.uid)) !== null && _a !== void 0 ? _a : '';
                        yondStudio = studios.find(function (s) { var _a; return ((_a = s.id) === null || _a === void 0 ? void 0 : _a.toString()) === currentStudioId_1; });
                        if (yondStudio) {
                            legalEntityAGB = yondStudio.yondAGBUrl;
                            legalEntityNameStorage = yondStudio.yondLegalEntityName;
                            localStorage.setItem('legalEntity.name', legalEntityNameStorage);
                            localStorage.setItem('legalEntity.agb', legalEntityAGB);
                        }
                        else {
                            console.log('Did not find yond studio to set agb url and legal name');
                        }
                        _b.label = 2;
                    case 2:
                        agbElement.each(function () {
                            var linkText = (0, cash_dom_1.default)(this).text();
                            (0, cash_dom_1.default)(this).html('<a href="' + legalEntityAGB + '" target="_blank">' + linkText + '</a>');
                        });
                        legalEntityElement.each(function () {
                            (0, cash_dom_1.default)(this).html(legalEntityNameStorage);
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        console.log("yond technology type detected, but no data-get='yondAGB' element found");
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return YondFinishService;
}());
exports.YondFinishService = YondFinishService;
